import MomentUtils from '@date-io/moment';
import { AppBar, Avatar, Button, ButtonGroup, ClickAwayListener, Dialog as DialogMUI, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fab, Fade, FormControl, FormControlLabel, Grid, Icon, IconButton, InputLabel, List, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, OutlinedInput, Paper, Popper, Select, Slide, Switch, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { deepOrange, deepPurple } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import classnames from 'classnames';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { Component, createRef } from "react";
import AutoCompleteSelection from '../components/AutoCompleteSelection';
import EnhancedTableHead from '../components/EnhancedTableHead';
import SelectDropdown from '../components/SelectDropdown';
import { RowCountOptions } from "../Config";
import "../css/shipment.css";
import { ROLES } from '../Roles';
import { FCService } from "../Services/FCService";
import { ItemService } from "../Services/ItemService";
import { OrganisationService } from "../Services/OrganisationService";
import { ReturnsService } from "../Services/ReturnsService";
import { WarehouseService } from "../Services/WarehouseService";
import { convertShipmentStatusToString, format, formatNumber, format_export_new, format_display, format_invoice, getShipmentStatusBadge, getTimeInIST, numberToText, precision, titleCase, toInt, getReturnType } from '../Utils';
import EnhancedTableToolbar from '../components/EnhancedTableToolbar';
import ViewListIcon from '@material-ui/icons/ViewList';
import ReceiptIcon from '@material-ui/icons/Receipt';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PublishIcon from '@material-ui/icons/Publish';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" {...props} ref={ref} />
))

const styles = theme => ({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },
    fab: {
        margin: theme.spacing(1),
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    tablecell: {
        fontSize: '40pt',
        padding: '5px'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '20px',
    },
    table: {
        minWidth: 700
    },
    list: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    formControlForm: {
        margin: theme.spacing(1),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    formControlLeft: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
    orangeAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: deepOrange[500],
    },
    purpleAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: deepPurple[500],
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    heading: {
        fontWeight: 500,
        color: 'black'
    }
});

class Returns extends Component {

    constructor(props) {
        super(props);
        this.state = {
            company_data: {
                pan: "",
                name: "",
                bill_to: "",
            },
            data: [],
            originalData: [],
            current_rows: [],
            numItemsPerPage: 10,
            currentPageNumber: 0,
            totalItems: 0,
            totalPages: 0,
            filter: '',
            new_return: { new: true, id: undefined, delivery_challan_identifier: '', type: 'R', warehouse_id: "", fc_id: "", returns_date: moment(), invoice_no: "", interstate: "1", narration: "", items: [] },
            show: false,
            showAddItem: false,
            showDetails: false,
            columns: [
                { id: 'index', numeric: false, disablePadding: true, label: '', sortable: false },
                { id: 'type', numeric: false, disablePadding: true, label: 'Type', sortable: false },
                { id: 'delivery_challan_identifier', numeric: false, disablePadding: true, label: 'Delivery Challan', sortable: true },
                { id: 'invoice_no', numeric: false, disablePadding: true, label: 'Invoice No', sortable: true },
                { id: 'fc_name', numeric: false, disablePadding: true, label: 'Source', sortable: true },
                { id: 'warehouse_name', numeric: false, disablePadding: true, label: 'Destination', sortable: true },
                { id: 'interstate', numeric: false, disablePadding: true, label: 'Interstate', sortable: true },
                { id: 'narration', numeric: false, disablePadding: true, label: 'Narration', sortable: true },
                { id: 'returns_date', numeric: false, disablePadding: true, label: 'Return Date', sortable: true },
                { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true },
                { id: 'actions', numeric: false, disablePadding: true, label: '', sortable: false },
            ],
            order: 'desc',
            orderBy: 'returns_date',
            master_items: [],
            master_fc: [],
            master_warehouse: [],
            master_status: [{ id: '2', name: 'Completed' }, { id: '3', name: 'Cancelled' }],
            master_interstate: [{ id: '1', name: 'Interstate' }, { id: '0', name: 'Local' }],
            master_types: [{ id: '-1', name: 'All' }, { id: 'R', name: 'Returns' }, { id: 'T', name: 'FC Transfers' }],
            startDate: moment().subtract(1, "month"),
            endDate: moment().add(7, "days"),
            fc_names: [],
            project_names_master: [],
            selected_warehouse: "",
            selected_item_id: "",
            selected_status: "-1",
            selected_interstate: "",
            selected_type: "-1",
            selected_fc: "",
            items_row: [],
            txn_type_row: [],
            showChangeStatus: false,
            selected_return: { status: "0" },
            error_fields: { delivery_challan_identifier: false, warehouse_id: false, fc_id: false, returns_date: false, invoice_no: false, narration: false },
            item_rows: [],
            output: '',
            showOutput: false,
            showPopper: false,
            anchorEl: null,
            showImportDialog: false,
            importDate: moment(),
            importWarehouse: null,
            importFile: null
        }

        this.handleSelect = this.handleSelect.bind(this);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.createModifyReturn = this.createModifyReturn.bind(this);

        //Sort
        this.sortBy = this.sortBy.bind(this);

        this.showExportPopper = this.showExportPopper.bind(this);
        this.hsnExport = this.hsnExport.bind(this);
        this.handleClosePoper = this.handleClosePoper.bind(this);

        this.uploadFile = this.uploadFile.bind(this);
        this.importStockRef = createRef()
    }

    componentWillMount() {
        this.props.setTitle('Manage Returns');
        this.props.isLoading(true);
        this.fetchWarehouses();
        // this.fetchItems();
        this.fetchFCFilter();
        this.fetchItemFilter();
        this.fetchStatusFilter();
        this.fetchInterstateFilter();
        this.fetchTypeFilter();
        OrganisationService.getOrganisationDetails()
            .then(data => {
                this.setState({ company_data: data.organisation });
            })
    }

    fetchFCFilter = () => {
        FCService.getFCs()
            .then((data) => {
                let fc_names = data.fcs.map((fc) => (
                    <MenuItem key={fc.id} value={fc.id}>{fc.name}</MenuItem>
                ));
                fc_names.unshift(<MenuItem key={"-1"} value={"-1"}>All FCs</MenuItem>);
                this.setState({ master_fc: data.fcs, fc_names: fc_names });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    fetchItemFilter = () => {
        ItemService.getItemList()
            .then((data) => {
                this.setState({ master_items: data.items });
                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    fetchStatusFilter = () => {
        let txn_type_rows = this.state.master_status.map((txn_type) => (
            <MenuItem key={txn_type.id} value={txn_type.id}>{txn_type.name}</MenuItem>
        ));
        txn_type_rows.unshift(<MenuItem key={"-1"} value={"-1"}>All Status</MenuItem>);
        this.setState({ master_status: txn_type_rows });
    }

    fetchInterstateFilter = () => {
        let interstate_rows = this.state.master_interstate.map((option) => (
            <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
        ));
        interstate_rows.unshift(<MenuItem key={"-1"} value={"-1"}>All</MenuItem>);
        this.setState({ master_interstate_rows: interstate_rows });
    }

    fetchTypeFilter = () => {
        let rows = this.state.master_types.map((option) => (
            <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
        ));
        this.setState({ master_type_rows: rows });
    }

    fetchWarehouses() {
        WarehouseService.getWarehouses()
            .then((data) => {
                let warehouse_names = data.warehouses.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                ));
                warehouse_names.unshift(<MenuItem key={"-1"} value={"-1"}>All Warehouses</MenuItem>);
                this.setState({ master_warehouse: data.warehouses, warehouse_names: warehouse_names });
            })
            .catch((error) => {
                console.log("Error while fetching Warehouse list");
            });
    }

    componentDidMount() {
        this.fetchData(0, this.state.numItemsPerPage);
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage: event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if (this.state.currentPageNumber > page) {
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    exportReport = async () => {
        this.props.isLoading(true);
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let warehouse_id = this.state.selected_warehouse === "-1" ? null : this.state.selected_warehouse;
        let fc_id = this.state.selected_fc === "" ? null : this.state.selected_fc;
        let item_id = this.state.selected_item_id === "" ? null : this.state.selected_item_id;
        let status = this.state.selected_status === "-1" ? '0,1,2,3' : this.state.selected_status;
        let filter = this.state.filter === "" ? null : this.state.filter;
        let interstate = this.state.selected_interstate === "" ? null : this.state.selected_interstate;
        let type = this.state.selected_type === "-1" ? "R,T" : this.state.selected_type;
        let fileName = `Returns-${moment.utc(this.state.startDate).format(format_export_new)}-${moment.utc(this.state.endDate).format(format_export_new)}.xlsx`;
        ReturnsService.getReturnsExport(0, this.state.totalItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), warehouse_id, fc_id, interstate, status, item_id, filter, sort, direction, type)
            .then(response => {
                // fileName = response.headers.get('content-disposition')
                //                 .split(';')
                //                 .find(n => n.includes('filename='))
                //                 .replace('filename=', '')
                //                 .trim();
                return response.blob();
            })
            .then((blob) => {
                this.props.isLoading(false);
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                // 3. Append to html page
                document.body.appendChild(link);
                // 4. Force download
                link.click();
                // 5. Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(error => {
                this.props.isLoading(false);
                console.log(error);
            });
    }

    fetchData(start, numberItems, showLoading = true) {
        if (showLoading) {
            this.props.isLoading(true);
        }
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let warehouse_id = this.state.selected_warehouse === "-1" ? null : this.state.selected_warehouse;
        let fc_id = this.state.selected_fc === "" ? null : this.state.selected_fc;
        let item_id = this.state.selected_item_id === "" ? null : this.state.selected_item_id;
        let status = this.state.selected_status === "-1" ? '0,1,2,3' : this.state.selected_status;
        let filter = this.state.filter === "" ? null : this.state.filter;
        let interstate = this.state.selected_interstate === "" ? null : this.state.selected_interstate;
        let type = this.state.selected_type === "-1" ? "R,T" : this.state.selected_type;

        ReturnsService.getTotalCount(warehouse_id, fc_id, item_id, status, interstate, filter, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), type)
            .then((data) => {
                this.setState({
                    totalItems: toInt(data.count),
                    totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
                });
                ReturnsService.getReturns(start, numberItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), warehouse_id, fc_id, interstate, status, item_id, filter, sort, direction, type)
                    .then((data) => {
                        this.setState({ data: data.returns, originalData: data.returns });
                        if (data.returns) {
                            data.returns.forEach((returns) => {
                                rows.push(<ReturnDetails classes={this.props.classes} key={returns.id} returns={returns} changeStatus={this.changeStatus} printInvoice={this.printInvoice} edit={this.edit} duplicateReturn={this.duplicateReturn} showDetails={this.showDetails} removeReturn={this.removeReturn} />);
                            });
                            this.setState({
                                current_rows: rows
                            });
                        }
                        if (showLoading) {
                            this.props.isLoading(false);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (showLoading) {
                            this.props.isLoading(false);
                        }
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleChangeReturnDate = (date) => {
        this.setState(prevState => ({
            new_return: {
                ...prevState.new_return,
                returns_date: date
            }
        }));
    }

    handleChange = (e) => {
        let change = this.state.new_return;
        if (e.target.name === 'interstate') {
            change[e.target.name] = e.target.checked ? '1' : '0';
        } else if (e.target.name === 'type') {
            change[e.target.name] = e.target.checked ? 'T' : 'R';
        } else {
            change[e.target.name] = e.target.value;
        }
        let error_fields = this.state.error_fields;
        error_fields[e.target.name] = e.target.value ? false : true;

        this.setState({
            new_return: change,
            error_fields: error_fields
        });
    }

    edit = (e, returns) => {
        if (returns) {
            let items = JSON.parse(JSON.stringify(returns.items));
            let rows = this.updateReturnItemRows(items);
            this.setState({ new_return: { new: false, id: returns.id, delivery_challan_identifier: returns.delivery_challan_identifier, type: returns.type, warehouse_id: returns.warehouse_id, fc_id: returns.fc_id, returns_date: getTimeInIST(returns.returns_date), invoice_no: returns.invoice_no, interstate: returns.interstate, narration: returns.narration, items: items }, item_rows: rows });
        }
        this.handleShow();
    }

    duplicateReturn = (e, s) => {
        let returns = Object.assign({}, s);
        returns.id = null;
        if (returns) {
            let items = JSON.parse(JSON.stringify(returns.items));
            let rows = this.updateReturnItemRows(items);
            this.setState({ new_return: { new: true, id: undefined, delivery_challan_identifier: '', type: returns.type, warehouse_id: returns.warehouse_id, fc_id: returns.fc_id, returns_date: getTimeInIST(returns.returns_date), invoice_no: returns.invoice_no, interstate: returns.interstate, narration: returns.narration, items: items }, item_rows: rows });
        }
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_return: { new: true, id: undefined, delivery_challan_identifier: '', type: 'R', warehouse_id: "", fc_id: "", returns_date: moment(), invoice_no: "", interstate: "1", narration: "", items: [] },
            error_fields: { delivery_challan_identifier: false, project_id: false, user_id: false, item_id: false, txn_type: false, qty: false, comments: false, narration: false },
            item_rows: []
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    showDetails = (e, returns) => {
        let return_details = JSON.parse(JSON.stringify(returns));
        let rows = this.returnItemDetailsRows(return_details);
        this.setState({ return_details: return_details, return_details_rows: rows });
        this.handleShowDetails();
    }

    removeReturn = (e, returns) => {
        this.props.showConfirmDialog("Confirm remove Return?", undefined, () => {
            ReturnsService.removeReturn(returns.id)
                .then(data => {
                    this.props.showSnackBar('Removed Return.', 'success');
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, false);
                })
                .catch(error => {
                    this.props.showSnackBar('Could not remove Return. Please try again or contact admin.', 'error');
                });
            this.props.closeConfirmDialog();
        });
    }

    handleShowDetails = () => {
        this.setState({ showDetails: true });
    }

    handleCloseDetails = () => {
        this.setState({
            showDetails: false,
            return_details: null,
            return_details_rows: []
        });
    }

    returnItemDetailsRows = (return_details) => {
        let items = return_details.items;
        return items.filter(i => toInt(i.status) !== -1).map(item => (
            <ItemDisplayDetails key={item.item_id} item={item} interstate={return_details.interstate === 1} master_items={this.state.master_items} classes={this.props.classes} />
        ));
    }

    confirmSave = () => {
        let new_return = this.state.new_return;
        new_return.is_new = new_return.new;
        new_return.returns_date = moment(new_return.returns_date).utc().format(format);
        this.props.isLoading(true);
        let headers = { user_id: this.props.user.id };
        ReturnsService.createReturn(headers, new_return)
            .then((response) => {
                this.props.closeConfirmDialog();
                this.props.isLoading(false);
                this.handleClose();
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                this.props.showSnackBar(`Return created.`, 'success');
            })
            .catch(error => {
                if (error.error_delivery_challan_identifier) {
                    this.props.showSnackBar(error.errorMessage, 'error');
                } else if (error.error_invoice_no) {
                    this.props.showSnackBar(error.errorMessage, 'error');
                } else {
                    this.props.showSnackBar(`Something went wrong. Please try again later.`, 'error');
                }
                this.props.closeConfirmDialog();
                this.props.isLoading(false);
            });
    }

    createModifyReturn(e) {
        e.preventDefault();
        let new_return = this.state.new_return;
        // new_return.returns_date = moment(new_return.returns_date).format(format);
        // new_return.items = new_return.items.filter(i => ( (i.case_size || 0) > 0) && ((i.units || 0) > 0) && ((i.weight || 0) > 0));
        let error_fields = this.state.error_fields;
        if (new_return.delivery_challan_identifier && new_return.type && new_return.warehouse_id && new_return.fc_id && new_return.invoice_no && new_return.items.length > 0 && new_return.items.filter(i => (i.units || 0) > 0).length === new_return.items.length) {
            // && moment(new_return.returns_date) >= moment().startOf('day')
            this.setState({ new_return: new_return }, () => this.props.showConfirmDialog("Create Return?", "Confirm", this.confirmSave));
            return;
        }

        if (!new_return.delivery_challan_identifier) {
            error_fields.delivery_challan_identifier = true;
        }
        if (!new_return.warehouse_id) {
            error_fields.warehouse_id = true;
        }
        if (!new_return.fc_id) {
            error_fields.fc_id = true;
        }

        if (!new_return.invoice_no) {
            error_fields.invoice_no = true;
        }
        // if(!(moment(new_return.returns_date) >= moment().startOf('day'))){
        //     error_fields.returns_date = true;
        // }
        if (new_return.items.length === 0 || new_return.items.filter(i => (i.units || 0) > 0).length !== new_return.items.length) {
            this.props.showSnackBar('Please add items, their quantities and proceed', 'error');
        }
        this.setState({ error_fields: error_fields });
    }

    handleSelect(eventKey, e) {
        if (eventKey === 'prev') {
            if ((this.state.currentPageNumber) > 0) {
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if (eventKey === 'next') {
            if ((this.state.currentPageNumber) < this.state.totalPages) {
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage) {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    handleChangeSearchText = (e) => {
        this.setState({ filter: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, true));
    }

    handleWarehouseSelection = (e) => {
        this.setState({ selected_warehouse: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleFCSelection = (e) => {
        this.setState({ selected_fc: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleStatusSelection = (e) => {
        this.setState({ selected_status: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleInterstateSelection = (e) => {
        this.setState({ selected_interstate: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleTypeSelection = (e) => {
        this.setState({ selected_type: e.target.value }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    changeStatus = (event, returns) => {
        if (this.props.user.roles.includes(ROLES.ADMIN)) {
            if (returns.status !== '2' && returns.status !== '3') {
                this.setState({ selected_return: returns }, () => this.handleShowChangeStatus());
            } else {
                this.props.showSnackBar('Cannot change state of an Completed or Cancelled Return', 'warning');
            }
        }
    }

    handleShowChangeStatus = () => {
        this.setState({ showChangeStatus: true });
    }

    handleCloseChangeStatus = () => {
        this.setState({ showChangeStatus: false, selected_return: { status: "0" } });
    }

    handleCloseImportDialog = () => {
        this.setState({ showImportDialog: false, importDate: moment(), importFile: null, importWarehouse: null });
    }

    handleShowImportDialog = () => {
        this.setState({ showImportDialog: true });
    }

    changeStatusForReturn = (e) => {
        this.props.showConfirmDialog("Confirm change status?", undefined, () => {
            let headers = { user_id: this.props.user.id };
            ReturnsService.changeReturnStatus(headers, { id: this.state.selected_return.id, status: e.target.value })
                .then((data) => {
                    this.props.showSnackBar(`Changed status of Return`, 'success');
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, false);
                    this.props.closeConfirmDialog();
                    this.handleCloseChangeStatus();
                })
                .catch(error => {
                    console.log(error);
                    this.props.showSnackBar(`Failed to change status. Please try again.`, 'error');
                });
        });
    }

    removeItem = (e, item) => {
        if (toInt(item.units) !== 0) {
            this.props.showConfirmDialog("Confirm Remove?", undefined, () => {
                this.confirmRemove(item, this.props.closeConfirmDialog);
            });
        } else {
            this.confirmRemove(item, undefined);
        }
    }

    confirmRemove = (item, callback) => {
        let items = this.state.new_return.items;

        if (this.state.new_return.new) {
            items = items.filter((i) => i.item_id !== item.item_id);
        } else {
            let i = items.filter((i) => i.item_id === item.item_id)[0];
            i.status = "-1";
        }
        this.setState((prevState) => ({
            new_return: {
                ...prevState.new_return,
                items: items
            },
            item_rows: this.updateReturnItemRows(items)
        }), () => callback ? callback() : null);
    }

    handleItemChange = (e, field) => {
        let i = this.state.new_return.items;
        let item = i.filter((i) => i.item_id === e.target.name);
        if (item.length === 1) {
            item[0][field] = e.target.value;
        }
        this.setState((prevState) => ({
            new_return: {
                ...prevState.new_return,
                items: i
            }
        }));
    }

    updateReturnItemRows = (items) => {
        return items.filter(i => toInt(i.status) !== -1).map(item => (
            <ItemDetails key={item.item_id} item={item} master_items={this.state.master_items} handleItemChange={this.handleItemChange} removeItem={this.removeItem} classes={this.props.classes} />
        ));
    }

    handleAddItemClick = () => {
        if (this.state.master_items.filter((item) => this.state.new_return.items.filter((i) => i.item_id === item.id && toInt(i.status) === 1).length === 0).length > 0) {
            this.setState({ showAddItem: true });
        } else {
            this.props.showSnackBar(`No more Items left to add.`, 'info');
        }
    }

    handleShowAddItemReturn = () => {
        this.setState({ showAddItem: true });
    }

    handleCloseAddItemReturn = () => {
        this.setState({ showAddItem: false });
    }

    handleAddItemToReturn = (e) => {
        let item = this.state.master_items.filter(i => i.id === e.id)[0];
        let error_fields = this.state.error_fields;
        if (item) {
            let i = {
                item_id: item.id,
                item_name: item.name,
                units: "0",
                status: "1",
                rate: item.rate,
                igst: item.igst,
                cgst: item.cgst,
                sgst: item.sgst
            }
            let items = this.state.new_return.items;
            items = items.filter(i => i.item_id !== item.id);
            items.push(i);
            error_fields.items = items.length === 0 ? true : false;
            this.setState((prevState) => ({
                new_return: {
                    ...prevState.new_return,
                    items: items
                },
                error_fields: error_fields,
                item_rows: this.updateReturnItemRows(items)
            }), () => this.handleCloseAddItemReturn());
        }
    }

    handleCloseOutput = () => {
        this.setState({ showOutput: false, output: '' });
    }

    handleShowOutput = () => {
        this.setState({ showOutput: true });
    }

    getRupeeSymbol(doc, x, y) {
        doc.text('INR', x, y);
        // let rupee = "data:image/png;base64,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";
        // doc.addImage(rupee, 'PNG', column7X - 24, initialTableDataHeight + (index * item_lineheight) - 2.5, 2.5, 2.5);
    }

    printInvoice = (e, returns) => {
        // this.handleShowOutput();
        let company = this.state.company_data;
        var doc = new jsPDF({
            orientation: 'portrait',
            format: 'a4',
            compress: true
        });

        //Initial
        let startX = 10;
        let startY = 10;
        let endX = doc.internal.pageSize.width - 20;
        let endY = doc.internal.pageSize.height - 20;
        doc.setLineWidth(0.75)
        doc.rect(startX, startY, endX, endY);

        //Heading Section
        let contentEndX = endX + 10;
        let contentEndY = endY + 10;
        let headingHeight = 50;
        let footerheightY = contentEndY - 50;
        let footerTotalHeightY = contentEndY - 40;
        doc.line(startX, headingHeight, contentEndX, headingHeight);
        let contentcenter = startX + (contentEndX - 10) / 2;
        let fc = this.state.master_fc.filter(fc => fc.id === returns.fc_id)[0];
        doc.setFont("times", '', 'normal')
        doc.setFontSize(14);
        doc.text(`${returns.interstate === 1 ? 'TAX INVOICE' : 'TAX INVOICE'}`, contentcenter, startX + 8, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", 'bold');
        doc.setFontSize(32);
        doc.text(company.return_name, contentcenter, startX + 19, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", '', 'normal')
        doc.setFontSize(12);
        doc.text(fc.address1, contentcenter, startX + 25, { align: "center", maxWidth: contentEndX - 10 });
        doc.text(`${fc.address2 ? `${fc.address2}, ` : ''}${fc.address3 ? `${fc.address3}, ` : ''}${fc.address4 ? `${fc.address4}, ` : ''}`, contentcenter, startX + 30, { align: "center", maxWidth: contentEndX - 10 });
        doc.setFont("times", 'bold');
        doc.text(`GSTIN No ${fc.gstin}`, contentcenter, startX + 37, { align: "center", maxWidth: contentEndX - 10 });


        //Bill to, Invoice, Date Section
        let section2Height = headingHeight + 45;
        let invoiceStartX = contentEndX - 65;
        let invoiceStartY = headingHeight + 20;
        doc.line(startX, section2Height, contentEndX, section2Height);
        doc.line(invoiceStartX, invoiceStartY, contentEndX, invoiceStartY);
        doc.line(invoiceStartX, headingHeight, invoiceStartX, section2Height);

        // Bill To
        doc.setFont("times", 'bold');
        doc.setFontSize(12);
        doc.text('Bill To:', startX + 2, headingHeight + 5, { align: "left", maxWidth: invoiceStartX - 10 });

        doc.setFont("times", 'bold');
        doc.setFontSize(12);
        doc.text(company.return_bill_to, startX + 2, headingHeight + 12, { align: "left", maxWidth: invoiceStartX - 10 });

        let warehouse =
            returns.type === 'R'
                ? this.state.master_warehouse.find(w => w.id === returns.warehouse_id)
                : this.state.master_fc.find(f => f.id === returns.warehouse_id)
        if (returns.type === 'T') {
            warehouse = {
                address1: warehouse.address1,
                address2: warehouse.address2,
                city: warehouse.address3,
                state: warehouse.address4
            };
        }
        doc.setFont("times", '', 'normal')
        doc.setFontSize(9);
        doc.text(company.name, startX + 2, headingHeight + 17, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(warehouse.address1, startX + 2, headingHeight + 22, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(warehouse.address2, startX + 2, headingHeight + 27, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(warehouse.city, startX + 2, headingHeight + 32, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(`${warehouse.state ? `${warehouse.state} ` : ''}${warehouse.pin ? `- ${warehouse.pin}` : ''}`, startX + 2, headingHeight + 37, { align: "left", maxWidth: invoiceStartX - 10 });
        doc.text(`GSTIN No: ${warehouse.gst}`, startX + 2, headingHeight + 42, { align: "left", maxWidth: invoiceStartX - 10 });

        //Invoice
        doc.setFont("times", 'bold');
        doc.setFontSize(12);
        doc.text(`${returns.interstate === 1 ? 'Invoice' : 'Invoice'} No.`, invoiceStartX + 2, headingHeight + 5, { align: "left", maxWidth: contentEndX - 10 });
        doc.setFont("times", '', 'normal')
        doc.text(returns.invoice_no, invoiceStartX + 2, headingHeight + 10, { align: "left", maxWidth: contentEndX - 10 });
        doc.line(invoiceStartX, invoiceStartY - 7, contentEndX, invoiceStartY - 7);
        doc.text(`Delivery Challan: ${returns.delivery_challan_identifier || ''}`, invoiceStartX + 2, headingHeight + 18, { align: "left", maxWidth: contentEndX - 10 });

        //Invoice Date
        doc.setFont("times", 'bold');
        doc.setFontSize(12);
        doc.text('Date', invoiceStartX + 2, invoiceStartY + 5, { align: "left", maxWidth: contentEndX - 10 });
        doc.setFont("times", '', 'normal')
        doc.text(getTimeInIST(returns.returns_date).format(format_invoice), invoiceStartX + 2, invoiceStartY + 12, { align: "left", maxWidth: contentEndX - 10 });


        //Table Heading
        // let tableHeadingHeight = section2Height - 10;
        let column1X = startX + 2;
        let column2X = invoiceStartX - 46;
        let column3X = invoiceStartX - 23;
        let column4X = invoiceStartX - 10;
        let column5X = invoiceStartX + 2;
        let column6X = contentEndX - 43;
        let column7X = contentEndX - 23;
        let initialTableY = section2Height + 5;
        doc.line(startX, section2Height + 10, contentEndX, section2Height + 10);

        doc.line(contentEndX - 27, section2Height, contentEndX - 27, footerTotalHeightY);
        doc.line(contentEndX - 48, section2Height, contentEndX - 48, footerTotalHeightY);
        doc.line(invoiceStartX, section2Height, invoiceStartX, footerheightY);
        doc.line(invoiceStartX - 13, section2Height, invoiceStartX - 13, footerheightY);
        doc.line(invoiceStartX - 26, section2Height, invoiceStartX - 26, footerheightY);
        doc.line(invoiceStartX - 48, section2Height, invoiceStartX - 48, footerheightY);

        doc.setFont("times", 'bold');
        doc.setFontSize(11);
        doc.text('AMOUNT', column7X, initialTableY, { align: "left", maxWidth: contentEndX - 10 });
        doc.text('RATE', column6X, initialTableY, { align: "left", maxWidth: contentEndX - 25 });
        doc.text('UNITS', column5X, initialTableY, { align: "left", maxWidth: contentEndX - 45 });
        doc.text('QTY', column4X, initialTableY, { align: "left", maxWidth: invoiceStartX + 4 });
        doc.text('GST', column3X, initialTableY, { align: "left", maxWidth: invoiceStartX - 22 });
        doc.text('HSN Code', column2X, initialTableY, { align: "left", maxWidth: invoiceStartX - 24 });
        doc.text('Description of Goods', column1X, initialTableY, { align: "left", maxWidth: invoiceStartX - 50 });

        // Items
        doc.setFont("times", '', 'normal')
        doc.setFontSize(10);
        let item_lineheight = 5;
        let initialTableDataHeight = initialTableY + 10;
        returns.items.forEach((item, index) => {
            let fnsku = this.state.master_items.filter(i => i.id === item.item_id)[0].fnsku;
            doc.text(`${index + 1}. ${item.item_name} [${fnsku}]`, startX + 1, initialTableDataHeight + (index * item_lineheight), { align: "left", maxWidth: 75 });
            doc.text(`${item.hsn_code}`, column3X - 4, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 23 });
            doc.text(`${returns.interstate === 1 ? item.igst : parseFloat(item.cgst) + parseFloat(item.sgst)}%`, column4X - 4, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 12 });
            doc.text(`${toInt(item.units)}`, column5X - 3, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 12 });
            doc.text(`PCS`, column5X + 1, initialTableDataHeight + (index * item_lineheight), { align: "left", maxWidth: 20 });
            this.getRupeeSymbol(doc, column7X - 24, initialTableDataHeight + (index * item_lineheight));
            doc.text(` ${formatNumber(item.rate)}`, column7X - 5, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 20 });
            this.getRupeeSymbol(doc, column7X - 3, initialTableDataHeight + (index * item_lineheight));
            doc.text(` ${formatNumber(parseFloat(item.rate) * toInt(item.units))}`, contentEndX - 1, initialTableDataHeight + (index * item_lineheight), { align: "right", maxWidth: 25 });
        });

        // Items Summary 
        let summaryStart = startX + 1, summaryEnd = contentEndX - 1, summaryHeight = footerheightY - 45;
        let roundOff = 0;
        let total_amount = 0;
        let igst_amount_map = new Map();
        let cgst_amount_map = new Map();
        let sgst_amount_map = new Map();
        total_amount = returns.items.reduce(function (items, item, idx) {
            return items + ((toInt(item.units)) * parseFloat(item.rate))
        }, 0);
        if (returns.interstate === 1) {
            returns.items.forEach(item => {
                if (!igst_amount_map.has(item.igst)) {
                    igst_amount_map.set(item.igst, 0)
                }
            })
            igst_amount_map.forEach((value, key) => {
                igst_amount_map.set(key, returns.items.filter(i => parseFloat(i.igst) === parseFloat(key)).reduce(function (items, item, idx) {
                    let tax_rate = parseFloat(item.igst) / 100;
                    return items + ((toInt(item.units) * item.rate) * tax_rate)
                }, 0))
            });
        } else {
            returns.items.forEach(item => {
                if (!cgst_amount_map.has(item.cgst)) {
                    cgst_amount_map.set(item.cgst, 0)
                    sgst_amount_map.set(item.sgst, 0)
                }
            })
            cgst_amount_map.forEach((value, key) => {
                cgst_amount_map.set(key, returns.items.filter(i => parseFloat(i.cgst) === parseFloat(key)).reduce(function (items, item, idx) {
                    let tax_rate = parseFloat(item.cgst) / 100;
                    return items + ((toInt(item.units) * item.rate) * tax_rate)
                }, 0));
            });
            sgst_amount_map.forEach((value, key) => {
                sgst_amount_map.set(key, returns.items.filter(i => parseFloat(i.sgst) === parseFloat(key)).reduce(function (items, item, idx) {
                    let tax_rate = parseFloat(item.sgst) / 100;
                    return items + ((toInt(item.units) * item.rate) * tax_rate)
                }, 0))
            });
        }
        let total_igst = Array.from(igst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
        let total_cgst = Array.from(cgst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
        let total_sgst = Array.from(sgst_amount_map.values()).reduce((sum, next) => sum + next, 0) || 0;
        let total = Math.round(total_amount + (returns.interstate === 1 ? (total_igst) : (total_cgst + total_sgst)));
        roundOff = total - (total_amount + (returns.interstate === 1 ? (total_igst) : (precision(total_cgst) + precision(total_sgst))));
        summaryHeight = (total_cgst > 0) ? summaryHeight : summaryHeight + 5;
        doc.setFont("times", 'bold');
        doc.setFontSize(10);
        doc.text('Total Taxable Value', summaryStart, summaryHeight, { align: "left", maxWidth: 77 });
        this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight);
        doc.text(`${formatNumber(total_amount)}`, summaryEnd, summaryHeight, { align: "right", maxWidth: 25 });

        if (returns.interstate === 1) {
            let i = 0
            igst_amount_map.forEach((value, key) => {
                doc.text(`ADD IGST  ${key}%`, summaryStart, summaryHeight + 5 + (i * 5), { align: "left", maxWidth: 77 });
                this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 5 + (i * 5));
                doc.text(`${formatNumber(value)}`, summaryEnd, summaryHeight + 5 + (i * 5), { align: "right", maxWidth: 25 });
                i++
            })
        } else {
            let i = 0
            cgst_amount_map.forEach((value, key) => {
                let sgst = sgst_amount_map.get(key)
                doc.text(`ADD CGST  ${key}%`, summaryStart, summaryHeight + 5 + (i * 10), { align: "left", maxWidth: 77 });
                doc.text(`ADD SGST  ${key}%`, summaryStart, summaryHeight + 10 + (i * 10), { align: "left", maxWidth: 77 });

                this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 5 + (i * 10));
                doc.text(`${formatNumber(value)}`, summaryEnd, summaryHeight + 5 + (i * 10), { align: "right", maxWidth: 25 });
                this.getRupeeSymbol(doc, summaryEnd - 25, summaryHeight + 10 + (i * 10));
                doc.text(`${formatNumber(sgst)}`, summaryEnd, summaryHeight + 10 + (i * 10), { align: "right", maxWidth: 25 });
                i++
            })
        }

        let round_off_height = (total_igst === 0) ? summaryHeight + 25 : summaryHeight + 20;
        doc.text('ROUND OFF', summaryStart, round_off_height, { align: "left", maxWidth: 77 });
        this.getRupeeSymbol(doc, summaryEnd - 25, round_off_height);
        doc.text(`${formatNumber(roundOff)}`, summaryEnd, round_off_height, { align: "right", maxWidth: 25 });

        // Items Reference Section
        let referenceStart = startX + 1, referenceHeight = footerheightY - 15;
        doc.setFont("times", 'bold');
        doc.setFontSize(10);
        doc.text('Reference', referenceStart, referenceHeight, { align: "left", maxWidth: 77 });
        doc.setFontSize(12);
        doc.setFont('times', '', 'normal');
        doc.text(`Narration: ${returns.narration || ''}`, referenceStart, referenceHeight + 5, { align: "left", maxWidth: 75 });


        // Footer
        let totalInWordsSectionX = invoiceStartX - 48;
        let totalInWordsSectionY = footerheightY + 30;
        doc.line(startX, footerheightY, contentEndX, footerheightY);
        doc.line(startX, footerTotalHeightY, contentEndX, footerTotalHeightY);
        doc.line(startX, totalInWordsSectionY, totalInWordsSectionX, totalInWordsSectionY);
        doc.line(totalInWordsSectionX, footerTotalHeightY, totalInWordsSectionX, contentEndY);

        doc.setFont("times", 'bold');
        doc.setFontSize(10);
        doc.text(`Total`, startX + 2, footerheightY + 6, { align: "left" });
        this.getRupeeSymbol(doc, contentEndX - 26, footerheightY + 5.75);
        doc.text(`${formatNumber(total)}`, contentEndX - 1, footerheightY + 6, { align: "right", maxWidth: 25 });

        doc.setFont("times", '', 'normal')
        doc.setFontSize(10);
        doc.text(`Amount (in words)`, startX + 2, footerheightY + 15, { align: "left" });
        doc.text(`Rupees ${titleCase(numberToText(total))} only`, startX + 2, footerheightY + 20, { align: "left", maxWidth: totalInWordsSectionX - 15 });

        doc.setFont("times", 'bold');
        doc.setFontSize(12);
        doc.text(`Company's PAN: ${company.pan}`, startX + 2, totalInWordsSectionY + 12, { align: "left" });


        doc.setFont("times", '', 'normal')
        doc.setFontSize(12);
        doc.text(`For ${company.name}`, contentEndX - 5, footerheightY + 24, { align: "right" });
        doc.text(`Authorised Signatory`, contentEndX - 5, totalInWordsSectionY + 15, { align: "right" });

        // doc.output("dataurlnewwindow");
        // doc.save("Invoice-"+returns.invoice_no);
        // var output = doc.output('datauristring');
        // this.setState({output: output});
        let filename = `${returns.delivery_challan_identifier || ''}_${returns.fc_name}_GST${returns.invoice_no.substring(returns.invoice_no.lastIndexOf("/") + 1)}_Invoice.pdf`;
        doc.save(filename);
    }

    showExportPopper = (event) => {
        if (this.state.selected_type === "-1") {
            this.setState({ anchorEl: event.currentTarget, showPopper: true })
        } else {
            this.hsnExport(this.state.selected_type)
        }
    };

    hsnExport = type => {
        this.handleClosePoper()
        this.props.isLoading(true);
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let warehouse_id = this.state.selected_warehouse === "-1" ? null : this.state.selected_warehouse;
        let fc_id = this.state.selected_fc === "" ? null : this.state.selected_fc;
        let item_id = this.state.selected_item_id === "" ? null : this.state.selected_item_id;
        let status = this.state.selected_status === "-1" ? '0,1,2,3' : this.state.selected_status;
        let filter = this.state.filter === "" ? null : this.state.filter;
        let interstate = this.state.selected_interstate === "" ? null : this.state.selected_interstate;
        let fileName = `${type === 'R' ? 'Returns' : 'FC Transfer'}-${moment.utc(this.state.startDate).format(format_export_new)}-${moment.utc(this.state.endDate).format(format_export_new)} HSN Smmmary.xlsx`;
        ReturnsService.getReturnsExport(0, this.state.totalItems, moment.utc(this.state.startDate).format(format), moment.utc(this.state.endDate).format(format), warehouse_id, fc_id, interstate, status, item_id, filter, sort, direction, type, 'hsn')
            .then(response => {
                return response.blob();
            })
            .then((blob) => {
                this.props.isLoading(false);
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                // 3. Append to html page
                document.body.appendChild(link);
                // 4. Force download
                link.click();
                // 5. Clean up and remove the link
                link.parentNode.removeChild(link);
            })
            .catch(error => {
                this.props.isLoading(false);
                console.log(error);
            });
    }

    handleClosePoper = () => {
        this.setState({ anchorEl: null, showPopper: false })
    }

    uploadFile = () => {
        if (this.state.importDate && this.state.importWarehouse && this.state.importFile !== null) {
            const file = this.state.importFile
            const date = this.state.importDate
            const warehouse = this.state.importWarehouse
            this.props.showConfirmDialog("Confirm import?", undefined, () => {
                this.props.closeConfirmDialog();
                this.props.showProgressDialog('Processing...');

                const formData = new FormData();
                formData.append('file', file || null);
                formData.append('date', date.utc().format(format) || null);
                formData.append('warehouse', warehouse || null);
                ReturnsService.importStockTransfer(formData)
                    .then((data) => {
                        let message = (
                            <div>
                                <Typography variant='h4'>Processed</Typography>
                                <hr />
                                <div><b>FC_TRANSFER</b></div>
                                <div>Total Records: {data.FC_TRANSFER.total}</div>
                                <div>Success Records: {data.FC_TRANSFER.success}</div>
                                <hr />
                                <div><b>FC_REMOVAL</b></div>
                                <div>Total Records: {data.FC_REMOVAL.total}</div>
                                <div>Success Records: {data.FC_REMOVAL.success}</div>
                            </div>
                        )
                        this.props.showConfirmDialog(message, undefined, undefined);
                        this.fetchData(0, this.state.numItemsPerPage)
                        this.handleCloseImportDialog()
                    })
                    .catch(error => {
                        console.error(error)
                    })
                    .finally(() => this.props.closeProgressDialog())
            });
        }
    }

    render() {
        const { classes } = this.props;
        const { showPopper, anchorEl, } = this.state;
        return (
            <div className="Home">
                <Popper open={showPopper} anchorEl={anchorEl} transition>
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper style={{ padding: 20 }}>
                                <ClickAwayListener onClickAway={this.handleClosePoper}>
                                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                                        <Button onClick={() => this.hsnExport('R')} startIcon={<Icon>save_alt</Icon>}>Returns</Button>
                                        <Button onClick={() => this.hsnExport('T')} startIcon={<Icon>save_alt</Icon>}>FC Transfer</Button>
                                    </ButtonGroup>
                                </ClickAwayListener>
                            </Paper>
                        </Fade>
                    )}
                </Popper>
                <FormControl size="small" variant="outlined" className={classnames(classes.formControlLeft, classes.formControl)} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-fc-simple"
                    >
                        Source
                    </InputLabel>
                    <Select
                        value={this.state.selected_fc}
                        onChange={this.handleFCSelection}
                        input={
                            <OutlinedInput
                                labelWidth={20}
                                name="FC"
                                id="outlined-fc-simple"
                            />
                        }
                    >
                        {this.state.fc_names}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-warehouse-simple"
                    >
                        Destination
                    </InputLabel>
                    <Select
                        value={this.state.selected_warehouse}
                        onChange={this.handleWarehouseSelection}
                        input={
                            <OutlinedInput
                                labelWidth={80}
                                name="Destination Warehouse"
                                id="outlined-warehouse-simple"
                            />
                        }
                    >
                        {this.state.warehouse_names}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-status-simple"
                    >
                        Status
                    </InputLabel>
                    <Select
                        value={this.state.selected_status}
                        onChange={this.handleStatusSelection}
                        input={
                            <OutlinedInput
                                labelWidth={50}
                                name="Status"
                                id="outlined-txn_type-simple"
                            />
                        }
                    >
                        {this.state.master_status}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-interstate-simple"
                    >
                        Interstate
                    </InputLabel>
                    <Select
                        value={this.state.selected_interstate}
                        onChange={this.handleInterstateSelection}
                        input={
                            <OutlinedInput
                                labelWidth={70}
                                name="Status"
                                id="outlined-interstate-simple"
                            />
                        }
                    >
                        {this.state.master_interstate_rows}
                    </Select>
                </FormControl>
                <FormControl size="small" variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor="outlined-interstate-simple"
                    >
                        Type
                    </InputLabel>
                    <Select
                        value={this.state.selected_type}
                        onChange={this.handleTypeSelection}
                        input={
                            <OutlinedInput
                                labelWidth={70}
                                name="Status"
                                id="outlined-type-simple"
                            />
                        }
                    >
                        {this.state.master_type_rows}
                    </Select>
                </FormControl>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DatePicker
                        margin="normal"
                        label="From"
                        size="small"
                        value={this.state.startDate}
                        onChange={this.handleChangeStartDate}
                        format='DD MMM YYYY'
                        maxDate={this.state.endDate}
                        variant="dialog"
                        inputVariant="outlined"
                        className={classes.formControl}
                        style={{ float: "left", height: "100%", marginTop: "24px" }}
                    />
                    <DatePicker
                        margin="normal"
                        label="To"
                        size="small"
                        value={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                        format='DD MMM YYYY'
                        variant="dialog"
                        inputVariant="outlined"
                        minDate={this.state.startDate}
                        className={classes.formControl}
                        style={{ float: "left", height: "100%", marginTop: "24px" }}
                    />
                </MuiPickersUtilsProvider>
                <div className="container">
                    <Paper className={this.props.classes.root} style={{ width: "100%", marginTop: "50px", paddingLeft: "5px", paddingRight: "5px", marginBottom: 75 }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <div style={{}} onClick={this.handleShowImportDialog}>
                                <Button variant='outlined'>
                                    Import Amazon Stock Transfer
                                </Button>
                            </div>
                            <EnhancedTableToolbar
                                searchText={this.state.filter}
                                onSearchTextChange={this.handleChangeSearchText}
                                searchPlaceholder="Delivery Challan No, Invoice No Or Vehicle No"
                                exportReport={this.exportReport} />
                            <div style={{}} onClick={this.showExportPopper}>
                                <Button>HSN Summary</Button>
                            </div>
                        </div>
                        <Table className={classes.table}>
                            <EnhancedTableHead
                                order={this.state.order}
                                orderBy={this.state.orderBy}
                                onRequestSort={this.sortBy}
                                rows={this.state.columns} />
                            <TableBody>
                                {this.state.current_rows}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={RowCountOptions}
                            component="div"
                            count={this.state.totalItems}
                            rowsPerPage={this.state.numItemsPerPage}
                            page={this.state.currentPageNumber}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                    </Paper>
                </div>
                <DialogMUI
                    fullScreen
                    TransitionComponent={Transition}
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                Returns
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    {/* <DialogTitle id="alert-dialog-title">Create Transaction</DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <Grid container alignItems="flex-start" spacing={1}>
                                <Grid item>
                                    <TextField
                                        id="delivery_challan_identifier"
                                        label="Delivery Challan"
                                        placeholder="Delivery Challan"
                                        name="delivery_challan_identifier"
                                        defaultValue={this.state.new_return.delivery_challan_identifier}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        error={this.state.error_fields.delivery_challan_identifier}
                                        helperText="Delivery Challan no"
                                        type="text"
                                        style={{ marginTop: '8px' }}
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id="invoice_no"
                                        label="Invoice No"
                                        placeholder="Invoice No"
                                        name="invoice_no"
                                        defaultValue={this.state.new_return.invoice_no}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        required
                                        error={this.state.error_fields.invoice_no}
                                        helperText="Enter Invoice No"
                                        type="text"
                                        style={{ marginTop: '8px' }}
                                    />
                                </Grid>
                                <Grid item>
                                    <SelectDropdown required error={this.state.error_fields.fc_id} label="FC" hint="Select Source" name="fc_id" options={this.state.master_fc} value={this.state.new_return.fc_id} onChange={this.handleChange} />
                                </Grid>
                                {
                                    this.state.new_return.type === 'R' ? (
                                        <Grid item>
                                            <SelectDropdown required error={this.state.error_fields.warehouse_id} disabled={this.state.master_warehouse.length === 0} label="Warehouse" hint="Select Destination" name="warehouse_id" options={this.state.master_warehouse} value={this.state.new_return.warehouse_id} onChange={this.handleChange} />
                                        </Grid>
                                    ) : (
                                        <Grid item>
                                            <SelectDropdown required error={this.state.error_fields.warehouse_id} label="FC" hint="Select Destination" name="warehouse_id" options={this.state.master_fc} value={this.state.new_return.warehouse_id} onChange={this.handleChange} />
                                        </Grid>
                                    )
                                }
                                <Grid item>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            margin="normal"
                                            label="Return Date"
                                            value={this.state.new_return.returns_date}
                                            onChange={this.handleChangeReturnDate}
                                            format='DD MMM YYYY'
                                            variant="dialog"
                                            inputVariant="outlined"
                                            style={{ marginTop: "8px" }}
                                            helperText="Select Return Date"
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={this.state.new_return.interstate === 1}
                                                onChange={this.handleChange}
                                                name='interstate'
                                                value={this.state.new_return.interstate}
                                            />
                                        }
                                        style={{ marginTop: 16, marginLeft: 8, marginRight: 8 }}
                                        label="Interstate"
                                    />
                                </Grid>
                                <Grid item>
                                    <Grid component="label" container alignItems="center" spacing={1} style={{ minWidth: 200, marginLeft: 16, marginTop: 12 }}>
                                        <Grid item>Return</Grid>
                                        <Grid item>
                                            <Switch
                                                checked={this.state.new_return.type === 'T'}
                                                onChange={this.handleChange}
                                                name='type'
                                                value={this.state.new_return.type}
                                            />
                                        </Grid>
                                        <Grid item>Tranfer</Grid>
                                    </Grid>
                                </Grid>
                                {/* <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.new_return.type === 'T'}
                                                    onChange={this.handleChange}
                                                    name='type'
                                                    value={this.state.new_return.type}
                                                />
                                            }
                                            style={{ marginTop: 10, marginLeft: 8, marginRight: 8}}
                                            label="Return / Transfer"
                                        /> */}
                            </Grid>
                            <div>
                                <TextField
                                    id="narration"
                                    label="Narration"
                                    placeholder="Narration"
                                    name="narration"
                                    defaultValue={this.state.new_return.narration}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    helperText="Enter Narration"
                                    type="text"
                                    style={{ marginTop: '8px', minWidth: 400 }}
                                    InputProps={{
                                        inputProps: { min: 0, maxLength: 10 }
                                    }}
                                />
                            </div>
                            <Divider />
                            <List className={this.props.classes.list}>
                                {this.state.item_rows}
                            </List>
                        </DialogContentText>
                        <Fab onClick={this.handleAddItemClick} variant="extended" color="secondary" aria-label="Add Item" className={classes.fab} style={{ position: 'fixed', top: '80%', left: '88%' }}>
                            <AddIcon />
                            Add Item
                        </Fab>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Close
                        </Button>
                        <Button onClick={this.createModifyReturn} color="primary" autoFocus>
                            Save
                        </Button>
                    </DialogActions>
                </DialogMUI>
                {this.state.return_details &&
                    <DialogMUI
                        fullWidth
                        maxWidth={'lg'}
                        TransitionComponent={Transition}
                        open={this.state.showDetails}
                        onClose={this.handleCloseDetails}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        scroll='paper'>
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton color="inherit" onClick={this.handleCloseDetails} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" className={classes.flex}>
                                    Return Details
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <Grid container spacing={1} style={{ flexGrow: 1, marginLeft: 10, marginBottom: 15 }} justifyContent="flex-start" alignItems="center">
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Delivery Challan Number</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.return_details.delivery_challan_identifier}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography variant="subtitle1" className={classes.heading}>Type</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {getReturnType(this.state.return_details.type)}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {this.state.return_details.interstate === 1 ? <Avatar className={classes.orangeAvatar}>INT</Avatar> : <Avatar className={classes.purpleAvatar}>LOC</Avatar>}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Invoice No</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.return_details.invoice_no}
                                    </Grid>
                                    <Grid item xs={6} />
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Return Date</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {getTimeInIST(this.state.return_details.returns_date).format(format_invoice)}
                                    </Grid>
                                    <Grid item xs={6} />
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Warehouse</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.return_details.warehouse_name}
                                    </Grid>
                                    <Grid item xs={6} />
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle1" className={classes.heading}>Fulfillment Center</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        {this.state.return_details.fc_name}
                                    </Grid>
                                    <Grid item xs={6} />
                                    {this.state.return_details.narration &&
                                        <Grid item xs={3}>
                                            <Typography variant="subtitle1" className={classes.heading}>Narration</Typography>
                                        </Grid>
                                    }
                                    {this.state.return_details.narration &&
                                        <Grid item xs={3}>
                                            {this.state.return_details.narration}
                                        </Grid>
                                    }
                                </Grid>
                                <Divider />
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <CustomTableCell>Item</CustomTableCell>
                                            <CustomTableCell align="left" padding='none'>FNSKU</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>HSN Code</CustomTableCell>
                                            <CustomTableCell align="right" padding='none'>Rate</CustomTableCell>
                                            <CustomTableCell align="right" padding='none' style={{ paddingRight: 16 }}>Units</CustomTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.return_details_rows}
                                    </TableBody>
                                </Table>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseDetails} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </DialogMUI>
                }
                <DialogMUI
                    open={this.state.showChangeStatus}
                    onClose={this.handleCloseChangeStatus}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title">Change Status</DialogTitle>
                    <DialogContent style={{ minWidth: "300px" }}>
                        <Select
                            value={this.state.selected_return.status}
                            onChange={(e) => this.changeStatusForReturn(e)}
                            input={
                                <OutlinedInput
                                    labelWidth={200}
                                    name="Status"
                                    id="outlined-status-simple"
                                />
                            }
                            style={{ width: '100%' }}
                        >
                            <MenuItem value={"2"}>{convertShipmentStatusToString("2")}</MenuItem>
                            <MenuItem value={"3"}>{convertShipmentStatusToString("3")}</MenuItem>
                        </Select>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseChangeStatus} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </DialogMUI>
                <DialogMUI
                    open={this.state.showAddItem}
                    onClose={this.handleCloseAddItemReturn}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 5 }}>Select Item</DialogTitle>
                    <DialogContent>
                        <FormControl className={classes.formControl} style={{ minWidth: "300px", minHeight: 150 }}>
                            <AutoCompleteSelection
                                menuIsOpen={true}
                                placeHolder="Select Item"
                                onChange={this.handleAddItemToReturn}
                                name="items"
                                value={[]}
                                error={this.state.error_fields.items}
                                options={this.state.master_items.filter((item) => this.state.new_return.items.filter((i) => i.item_id === item.id && toInt(i.status) === 1).length === 0).map(item => ({
                                    id: item.id,
                                    name: item.name,
                                    value: item.id,
                                    label: `${item.name} [${item.fnsku}]`,
                                    status: item.status
                                }))} />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseAddItemReturn} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </DialogMUI>
                <DialogMUI
                    fullScreen
                    TransitionComponent={Transition}
                    open={this.state.showOutput}
                    onClose={this.handleCloseOutput}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogContent>
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton color="inherit" onClick={this.handleCloseOutput} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" className={classes.flex}>
                                    Print
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <embed width='100%' height='700px' src={this.state.output} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseOutput} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </DialogMUI>
                <DialogMUI
                    fullWidth
                    maxWidth="sm"
                    open={this.state.showImportDialog}
                    onClose={this.handleCloseImportDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    <DialogTitle id="alert-dialog-title">Import Amazon stock transfer</DialogTitle>
                    <DialogContent style={{ minWidth: "300px" }}>
                        <Grid container justifyContent='center' alignItems='center'>
                            <Grid item xs={5}>
                                <Typography>
                                    Step 1: Select Warehouse
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl size="small" variant="outlined" className={classes.formControlForm} style={{ float: "left" }}>
                                    <InputLabel htmlFor="outlined-warehouse-import" required>
                                        Warehouse
                                    </InputLabel>
                                    <Select
                                        value={this.state.importWarehouse}
                                        required
                                        onChange={e => this.setState({ importWarehouse: e.target.value })}
                                        input={
                                            <OutlinedInput
                                                labelWidth={80}
                                                required
                                                name="Warehouse"
                                                id="outlined-warehouse-import"
                                            />
                                        }
                                    >
                                        {this.state.warehouse_names}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={5}>
                                <Typography>
                                    Step 2: Returns/Transfers Date
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        margin="normal"
                                        label="Date"
                                        size="small"
                                        required
                                        value={this.state.importDate}
                                        onChange={(date) => this.setState({ importDate: date })}
                                        format='DD MMM YYYY'
                                        variant="dialog"
                                        inputVariant="outlined"
                                        className={classes.formControlForm}
                                        style={{ float: "left", height: "100%" }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={5}>
                                <Typography>
                                    Step 3: Upload File
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <div style={{ marginLeft: 8, marginTop: 4, marginBottom: 4, width: 200 }}>
                                    <Button fullWidth variant='outlined' startIcon={<PublishIcon />} onClick={() => this.importStockRef.current.click()}>
                                        {this.state.importFile === null ? 'Select file' : 'Click to reselect'}
                                        <input ref={this.importStockRef} onChange={(e) => this.setState({ importFile: e.target.files.length > 0 ? e.target.files[0] : null })} type="file" accept=".csv" hidden style={{ display: 'none' }} />
                                    </Button>
                                    {
                                        this.state.importFile ? (
                                            <Typography variant='caption'>{this.state.importFile.name}</Typography>
                                        ) : null
                                    }
                                </div>
                            </Grid>
                        </Grid>
                        {/* <Select
                            value={this.state.selected_return.status}
                            onChange={(e) => this.changeStatusForReturn(e)}
                            input={
                                <OutlinedInput
                                    labelWidth={200}
                                    name="Status"
                                    id="outlined-status-simple"
                                />
                            }
                            style={{ width: '100%' }}
                        >
                            <MenuItem value={"2"}>{convertShipmentStatusToString("2")}</MenuItem>
                            <MenuItem value={"3"}>{convertShipmentStatusToString("3")}</MenuItem>
                        </Select> */}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseImportDialog} color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={this.uploadFile} color="primary">
                            Proceed
                        </Button>
                    </DialogActions>
                </DialogMUI>
                {this.state.master_warehouse.length !== 0 && this.state.master_fc.length !== 0 && this.state.master_items.length !== 0 &&
                    <Fab variant="extended" size="medium" onClick={this.edit} color="primary" aria-label="Add" className={this.props.classes.fab} style={{ position: 'fixed', top: '90%', left: '82%' }}>
                        <AddIcon />
                        Create Returns
                    </Fab>
                }
            </div>
        );
    }

}

class ReturnDetails extends Component {

    render() {
        const returns = this.props.returns;
        const classes = this.props.classes;

        return (
            <TableRow key={returns.id}>
                <TableCell scope="row" align="center" padding='none'>
                    {returns.interstate === 1 ? <Avatar className={classes.orangeAvatar}>INT</Avatar> : <Avatar className={classes.purpleAvatar}>LOC</Avatar>}
                </TableCell>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{getReturnType(returns.type)}</Typography>
                </TableCell>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{returns.delivery_challan_identifier}</Typography>
                </TableCell>
                <TableCell align="center" padding='none'><Typography variant="subtitle2">{returns.invoice_no}</Typography></TableCell>
                <TableCell align="center" padding='none'><Typography variant="subtitle2">{returns.fc_name}</Typography></TableCell>
                <TableCell align="center" padding='none'><Typography variant="subtitle2">{returns.warehouse_name}</Typography></TableCell>
                <TableCell align="center" padding='none'>
                    <Typography variant="body1" color="textSecondary">{toInt(returns.interstate) === 1 ? "Interstate" : "Local"}</Typography>
                </TableCell>
                <TableCell align="center" padding='none'>
                    <Typography variant="subtitle2" color="textSecondary">{returns.narration ? returns.narration : '-'}</Typography>
                </TableCell>
                <TableCell align="center" padding='none'>{getTimeInIST(returns.returns_date).format(format_display)}</TableCell>
                <TableCell align="center" padding='none' style={{ paddingTop: 10 }}>
                    <Typography variant="subtitle2" onClick={(e) => this.props.changeStatus(e, returns)}>
                        {getShipmentStatusBadge(returns.status)}
                        <br />
                        {getTimeInIST(returns.modified_date).format(format_display)}
                    </Typography>
                </TableCell>
                <TableCell align="right" padding='none'>
                    <div style={{ marginTop: 5 }}>
                        <Tooltip title="View Details" arrow>
                            <IconButton size="small" variant="outlined" style={{ marginRight: 10 }} onClick={(e) => this.props.showDetails(e, returns)}>
                                <ViewListIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Invoice" arrow>
                            <IconButton size="small" variant="outlined" style={{ marginRight: 10 }} onClick={(e) => this.props.printInvoice(e, returns)}>
                                <ReceiptIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Duplicate Return" arrow>
                            <IconButton size="small" style={{ marginRight: 10 }} onClick={(e) => this.props.duplicateReturn(e, returns)}>
                                <FileCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {returns.status !== '3' &&
                            <Tooltip title="Edit" arrow>
                                <IconButton size="small" variant="contained" style={{ marginRight: 10 }} onClick={(e) => this.props.edit(e, returns)}>
                                    <Icon fontSize="small">edit</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            <Tooltip title="Remove Return" arrow>
                                <IconButton size="small" color="secondary" style={{ marginRight: 10 }} onClick={(e) => this.props.removeReturn(e, returns)}>
                                    <Icon fontSize="small">delete</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                    </div>
                </TableCell>
            </TableRow>
        );
    }
}

class ItemDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            handleItemChange: props.handleItemChange
        }
    }


    handleChange = (e, field) => {
        this.state.handleItemChange(e, field);
        if (field !== 'dimension') {
            if ((parseFloat(e.target.value) || 0) <= 0) {
                this.setState({ error: true });
            } else {
                this.setState({ error: false });
            }
        } else {
            if (e.target.value.length === 0) {
                this.setState({ error: true });
            } else {
                this.setState({ error: false });
            }
        }

    }

    render() {
        const item = this.props.item;
        const item_details = this.props.master_items.filter(i => i.id === item.item_id)[0];
        return (
            <ListItem key={item.item_id} role={undefined} dense button>
                <ListItemText primary={<Typography type="subtitle1">{item.item_name}</Typography>}
                    secondary={<Typography type="title"><b>FNSKU:</b> {item_details.fnsku}</Typography>} style={{ width: "10%" }} />
                <ListItemText primary={<Typography type="title"><b>HSN:</b> {item_details.hsn_code}</Typography>} style={{ width: "5%" }} />
                <ListItemText primary={<Typography type="title"><b>Rate:</b> {item.rate || item_details.rate}</Typography>} style={{ width: "5%" }} />
                <TextField
                    label="Units"
                    error={this.state.error}
                    defaultValue={item.units}
                    onChange={(e) => this.handleChange(e, 'units')}
                    type="number"
                    name={item.item_id}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    className={this.props.classes.qtyField}
                    margin="normal"
                    variant="outlined"
                    required
                    helperText="Enter total Units"
                />
                <ListItemSecondaryAction>
                    {/* <IconButton aria-label="Edit" onClick={(e) => this.props.editItem(e, item)} className={this.props.classes.icon}>
                        <EditIcon />
                    </IconButton> */}
                    <IconButton aria-label="Delete" onClick={(e) => this.props.removeItem(e, item)} className={this.props.classes.icon}>
                        <DeleteIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        );
    }
}

class ItemDisplayDetails extends Component {

    render() {
        const item = this.props.item;
        const interstate = this.props.interstate;
        const classes = this.props.classes;
        const item_details = this.props.master_items.filter(i => i.id === item.item_id)[0];
        return (
            <TableRow key={item.item_id} className={classes.row}>
                <CustomTableCell style={{ paddingRight: 5 }}>
                    <ListItemText
                        primary={item.item_name}
                        secondary={interstate ? `IGST : ${item.igst}` : `CGST : ${item.cgst} SGST : ${item.sgst}`}
                        style={{ width: 140, paddingRight: 5 }} />
                </CustomTableCell>
                <CustomTableCell align="left" padding='none'>{item_details.fnsku}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{item_details.hsn_code}</CustomTableCell>
                <CustomTableCell align="right" padding='none'>{formatNumber(item.rate)}</CustomTableCell>
                <CustomTableCell align="right" padding='none' style={{ paddingRight: 16 }}>{item.units}</CustomTableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(Returns);